import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Icon } from '../../icon/index.js';
import { StyledAlert, Title, AlertContent } from './style.js';
import { FCThemeConsumer } from '../../../theming/FCTheme.js';

var Alert = function Alert(_a) {
  var fcStyle = _a.fcStyle,
      title = _a.title,
      icon = _a.icon,
      _b = _a.borderRadius,
      borderRadius = _b === void 0 ? true : _b,
      children = _a.children,
      className = _a.className,
      _onMouseOver = _a.onMouseOver,
      _onMouseOut = _a.onMouseOut,
      rest = __rest(_a, ["fcStyle", "title", "icon", "borderRadius", "children", "className", "onMouseOver", "onMouseOut"]);

  var iconComponent = /*#__PURE__*/React.createElement(Icon, {
    className: "notification-icon",
    "aria-hidden": true,
    icon: icon && icon
  });
  return /*#__PURE__*/React.createElement(FCThemeConsumer, null, function (themeContext) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledAlert, __assign({
      onMouseOver: function onMouseOver() {
        return _onMouseOver && _onMouseOver();
      },
      onMouseOut: function onMouseOut() {
        return _onMouseOut && _onMouseOut();
      },
      theme: themeContext.theme,
      borderRadius: borderRadius,
      className: className,
      fcStyle: fcStyle
    }, rest), title && /*#__PURE__*/React.createElement("header", null, icon && iconComponent, /*#__PURE__*/React.createElement(Title, {
      theme: themeContext.theme
    }, title)), children && /*#__PURE__*/React.createElement(AlertContent, {
      theme: themeContext.theme,
      fcStyle: fcStyle
    }, children)));
  });
};

export default Alert;
export { Alert };